import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';
import { CrudService } from "./crud.service";
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';
import { ComunidadTipoContrato, GenericResponse, SaveComunidadTipoContratoDto, SearchComunidadTipoContratoRequestDto } from '../model';

@Injectable({
    providedIn: 'root'
})
export class ComunidadTipoContratoService extends CrudService<ComunidadTipoContrato, number, SaveComunidadTipoContratoDto, SearchComunidadTipoContratoRequestDto> {

    constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
        super(_http, 'ComunidadTipoContrato', sharedFunctions);

    }

    getAll(): Observable<GenericResponse<ComunidadTipoContrato[]>> {
        return this._http.get<GenericResponse<ComunidadTipoContrato[]>>(this._serviceUrl + '', this.httpOptions);
    }
}